import React from 'react';
import { Sparkles, Layers, HeartHandshake, TrendingUp, CheckCircle, Award, Users, ShieldCheck } from 'lucide-react';
import { companyInfo } from '../../data/companyInfo';

export const StatsSection: React.FC = () => {
  const valuePillars = [
    { title: 'Smart Digital Experiences', icon: Sparkles, color: 'text-[#159DE8]' },
    { title: 'Scalable Software', icon: Layers, color: 'text-[#0F6DFF]' },
    { title: 'Connected Workflows', icon: HeartHandshake, color: 'text-[#FF851B]' },
    { title: 'Growth-Focused Marketing', icon: TrendingUp, color: 'text-[#FF5A36]' },
  ];

  return (
    <section className="bg-[#050A13] border-b border-[#1b2f4a] py-8 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        
        {/* Value Pillars Bar - matching reference screenshot layout */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 py-3 px-4 bg-[#071426] border border-[#1b2f4a] rounded-2xl shadow-inner">
          {valuePillars.map((pillar, idx) => {
            const Icon = pillar.icon;
            return (
              <div 
                key={idx} 
                className="flex items-center gap-3 p-2 justify-center text-center sm:text-left transition-transform hover:scale-[1.02]"
              >
                <div className={`p-2 rounded-xl bg-[#0B2342] ${pillar.color} shrink-0`}>
                  <Icon size={18} />
                </div>
                <span className="text-xs sm:text-sm font-semibold text-white tracking-wide">
                  {pillar.title}
                </span>
              </div>
            );
          })}
        </div>

        {/* 4 Company Statistics Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {companyInfo.stats.map((stat, idx) => (
            <div 
              key={idx}
              className="p-5 sm:p-6 rounded-2xl bg-[#0c1a2d]/80 border border-[#1b2f4a] hover:border-[#159DE8]/50 transition-all duration-300 shadow-card-dark group"
            >
              <div className="flex items-baseline gap-1">
                <span className="text-3xl sm:text-4xl lg:text-5xl font-black font-display tracking-tight text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-[#FF851B] group-hover:to-[#159DE8] transition-all">
                  {stat.value}
                </span>
              </div>
              <h3 className="text-sm font-bold text-white mt-2 group-hover:text-[#D5DFEC] transition-colors">
                {stat.label}
              </h3>
              {stat.sublabel && (
                <p className="text-xs text-[#8FA0B8] mt-1 font-normal">
                  {stat.sublabel}
                </p>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
